import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

// Hero Subcategory (bskr/layout-hero-subcategory) entrance. Global partial — the
// layout nests inside pages where per-block scripts aren't reliably enqueued.
// The block is two containers, each a 2-column row (text group + picture). We
// fade each row's segments in once, staggered, when that row scrolls into view.
// Two separate triggers (one per row) because the second container sits well
// below the first, so a single root trigger would reveal it while off-screen.
//
// Editor: skipped (wp.data only exists in Gutenberg). Reduced motion, or nested
// inside a Content Slider slide: segments are shown immediately, no animation
// (the horizontal Swiper translate breaks the vertical scroll trigger — see
// content-slider.js). Hiding is JS-only, so the block degrades gracefully (stays
// visible) if the script never runs. ScrollTrigger is synced with Lenis in main.js.

function start() {
  if (typeof window !== "undefined" && window.wp && window.wp.data) return;
  init();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", start);
} else {
  start();
}

// One animatable segment per column: the outermost text group or the picture.
// querySelector returns the first match in tree order, so the nested CTA group
// inside the text column is never picked on its own.
function rowSegments(row) {
  return Array.from(row.children)
    .map((col) => col.querySelector(".wp-block-group, .bskr-responsive-asset"))
    .filter(Boolean);
}

function init() {
  const roots = document.querySelectorAll(
    ".wp-block-bskr-layout-hero-subcategory"
  );
  if (!roots.length) return;

  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  roots.forEach((root) => {
    if (root.dataset.heroSubcategoryInited === "1") return;
    root.dataset.heroSubcategoryInited = "1";

    const rows = Array.from(root.querySelectorAll(".wp-bootstrap-blocks-row"));
    if (!rows.length) return;

    const isStatic = reduce || root.closest("[data-no-scroll-reveal]") !== null;

    rows.forEach((row) => {
      const segments = rowSegments(row);
      if (!segments.length) return;

      if (isStatic) {
        gsap.set(segments, { autoAlpha: 1, y: 0 });
        return;
      }

      gsap.set(segments, { autoAlpha: 0, y: 28 });
      gsap.to(segments, {
        autoAlpha: 1,
        y: 0,
        duration: 0.7,
        ease: "power2.out",
        stagger: 0.18,
        scrollTrigger: {
          trigger: row,
          start: "top 75%",
          once: true,
        },
      });
    });
  });
}
